import { createFileRoute, useParams } from '@tanstack/react-router';

import { WorkspaceExerciseFormScreen } from '@/features/exercises/components/WorkspaceExerciseFormScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/exercises/$id/edit')({
  beforeLoad: () => {
    requirePermission('engagement:update');
  },
  component: WorkspaceExerciseEditRoute,
  staticData: { crumb: 'Edit' },
});

function WorkspaceExerciseEditRoute() {
  const { id } = useParams({ from: '/_staff/admin/workspace/exercises/$id/edit' });
  return <WorkspaceExerciseFormScreen mode="edit" id={id} surface="workspace" />;
}
